import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-arrow",
  "use": "down-arrow-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"down-arrow\"><path d=\"M225.813 48.907 128 146.72 30.187 48.907 0 79.093 128 207.093 256 79.093z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol